// extracted by mini-css-extract-plugin
export default {"two":"SecTwo_two__J7wf2","main":"SecTwo_main__fqeg5","text":"SecTwo_text__VtgMl","types":"SecTwo_types__y0eMD","type":"SecTwo_type__QMcQh","arrow":"SecTwo_arrow__mpScn"};